import React, {useState} from 'react';
import { connect } from "react-redux";
import {
    CardBody,
    Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {useForm} from "react-hook-form";
import SelectGeneric from "../../../components/select/selectGeneric";
import {busPickupProvider} from "../../../providers/eventx/busPickupProvider";
import {busRouteProvider} from "../../../providers/eventx/busRouteProvider";
import {busDateProvider} from "../../../providers/eventx/busDateProvider";

const BusScheduleFilter = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id

    const [departure, setDeparture] = useState(filter?.item?.departure || null)
    const [busDate, setBusDate] = useState(filter?.item?.busDate || null);
    const [busPickup, setBusPickup] = useState(filter?.item?.busPickup || null);
    const [busRoute, setBusRoute] = useState(filter?.item?.busRoute || null);
    const [resetFields, setResetFields] = useState(false);

    const { handleSubmit } = useForm({
    });

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.departure;
            delete tmpFilter.item.busDate;
            delete tmpFilter.item.busPickup;
            delete tmpFilter.item.busRoute;
        }
        props.setFilter(tmpFilter);
        setResetFields(true)
    }

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            item : {
                departure: departure,
                busDate,
                busPickup,
                busRoute,
            }
        }
        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>Departure</Label>
                            <Input type="text" name="departure"
                                   placeholder="Codigo"
                                   value={departure}
                                   onChange={(e) => setDeparture(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Pickup - Drop off</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={busPickup}
                                setExternalValue={setBusPickup}
                                resetValue={resetFields}
                                provider={busPickupProvider}
                                customFilter={fbDataBaseId}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>Ruta</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={busRoute}
                                setExternalValue={setBusRoute}
                                resetValue={resetFields}
                                provider={busRouteProvider}
                                customFilter={fbDataBaseId}
                            />
                        </FormGroup>
                    </Col>

                </Row>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>Fecha</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={busDate}
                                resetValue={resetFields}
                                setExternalValue={setBusDate}
                                provider={busDateProvider}
                                customFilter={fbDataBaseId}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4" className="d-flex align-items-center">
                        <div >
                            <ButtonSearch/>
                            <ButtonClean onClick={cleanFields}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(BusScheduleFilter)